module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"search":"Encontrar página"},"en":{"search":"Find page"}}')
  delete Component.options._Ctor
}
